module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/076-suriname-8a90ee5d69016640b78575207f280e9f.svg";